// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectExternalShipmentPageLoading,
  selectExternalShipmentShowInitWaitingMessage,
  selectExternalShipmentsInStore,
} from '../_selectors/external_shipment.selectors';

export class ExternalShipmentDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectExternalShipmentPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectExternalShipmentShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectExternalShipmentsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
